import { render, staticRenderFns } from "./cmpMenu.vue?vue&type=template&id=54e7b69c&"
import script from "./cmpMenu.vue?vue&type=script&lang=js&"
export * from "./cmpMenu.vue?vue&type=script&lang=js&"
import style0 from "./cmpMenu.vue?vue&type=style&index=0&id=54e7b69c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports